import React from "react";
import { AlertManager, withAlert } from "react-alert";
import {
  registerAlertTrigger,
  IAlert,
} from "@rentiohq/shared-frontend/dist/utils/alert/alert.utils";
import { getMessageForError } from "@rentiohq/shared-frontend/dist/utils/error.utils";

interface IProps {
  alert: AlertManager;
}

class UtilAlertProvider extends React.PureComponent<IProps> {
  constructor(props: IProps) {
    super(props);

    const alertTrigger = ({ message = "", error, type, onClose }: IAlert) => {
      props.alert.show(error ? getMessageForError(error) : message, {
        type,
        onClose,
      });
    };
    registerAlertTrigger(alertTrigger);
  }

  // Lifecycle methods
  public render() {
    return this.props.children;
  }
}

export default withAlert()(UtilAlertProvider);
